<template>
  <div class="modal-content">
    <div class="modal">
      <div class="close">
        <button
          class="btn close-btn--secondary"
          @click="$emit('close-modal')"
        >
          <span>&times;</span>
        </button>
      </div>
      <div class="content">
        <img
          :src="require(`@/assets/theme/${realm}/imgs/onboarding_avatar.svg`)"
          alt="Avatar do tour"
          class="icon"
        >
        <div class="text">
          <p class="title">
            {{ modalData.title }}
          </p>
          <p class="bottom-line">
            {{ modalData.text }}
          </p>
        </div>
      </div>
      <div class="buttons">
        <button
          class="btn"
          @click="$emit('agreed')"
        >
          {{ modalData.buttonText }}
        </button>
      </div>
    </div>
    <div class="overlay" />
  </div>
</template>

<script>
const realmTheme = process.env.VUE_APP_THEME_REALM ?? process.env.VUE_APP_KEYCLOAK_REALM;

export default {
  name: 'ModalTour',

  props: {
    modalData: {
      type: Object,
      required: true
    }
  },

  data() {
    const realm = realmTheme  === 'Uppersoft'  ?  'upcities' : realmTheme;

    return {
      realm
    };
  }
};
</script>

<style lang="scss" scoped>
  .modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 1rem;
    background: $onboarding-bg;
    border-radius: 10px;
    z-index: 15;
    width: 90%;
    overflow: auto;
    max-height: 90vh;
    max-width: 411px;

    .btn {
      box-shadow: none;
    }

    .close {
      display: flex;
      justify-content: right;

      &-btn {
        &--secondary {
          width: 20px;
          height: 20px;
          cursor: pointer;
          background: transparent;
          align-items: center;
          justify-content: center;
          display: flex;
          color: $gray-50;
          font-weight: 300;
          font-size: $text-5xl;
        }
      }
    }

    .content {
      .icon {
        margin-left: auto;
        margin-right: auto;
        width: 9.375rem;
        height: 8.625rem;
        margin-bottom: 1rem;

        @include screen(tablet-big-up) {
          margin-bottom: 2rem;
        }
      }
    }

    .text {
      margin: 1rem;
      color: $gray-60;

      .title {
        color: $gray-60;
        margin-bottom: 5px;
        text-align: center;
        justify-content: center;

        @include text-xl(2);

        @include screen(phone-up) {
          @include title-xs(2);
        }
      }

      .bottom-line {
        font-size: $text-sm;
        text-align: center;

        @include screen(phone-up) {
          font-size: $text-base;
        }
      }
    }

    .buttons {
      margin: 1rem 0;

      @include screen(tablet-big-up) {
        margin: 2rem 0 1rem;
      }

      .btn {
        margin: auto;
        color: $white;
        background: $primary;
        padding: 0.75rem 3.5rem;
        border-radius: $radius-lg;
        font-size: $text-sm;
        font-family: $montserrat-semibold;
      }
    }
  }

  .overlay {
    background: black;
    opacity: 0.4;
    position: fixed;
    z-index: 14;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
